import { type Accessor, type Component, For, Show } from 'solid-js'
import Button from '~/components/Button'
import Icon from '~/components/Icon'
import SwipeAction from '~/components/SwipeAction'
import Table from '~/components/Table'
import type { DraftSpecType } from '~/types/ProductForm'

export interface FichaTabPropsType {
  specs: DraftSpecType[]
  isMobile: Accessor<boolean>
  isService: Accessor<boolean>
  openCreateSpec: () => void
  openEditSpec: (index: number) => void
  removeSpec: (index: number) => void
}

/** Pestaña Ficha técnica: características en tabla (desktop) o lista deslizable (móvil). */
const FichaTab: Component<FichaTabPropsType> = props => {
  return (
    <div class="space-y-4">
      <div class="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h3 class="font-semibold text-foreground">Ficha técnica</h3>
          <p class="text-xs text-foreground-subtle">{props.isService() ? 'Duración, modalidad, cobertura…' : 'Cilindrada, material, potencia… lo que describe sin crear variantes'}</p>
        </div>
        <Button size="sm" variant="soft" color="default" onClick={props.openCreateSpec} prependIcon="material-symbols-light:add">
          Añadir característica
        </Button>
      </div>

      <Show when={props.isMobile()}>
        <div class="space-y-2">
          <For each={props.specs}>
            {(spec, index) => (
              <SwipeAction
                rightOptions={[
                  { icon: 'material-symbols-light:edit-outline', action: () => props.openEditSpec(index()), color: 'warning', label: 'Editar' },
                  { icon: 'material-symbols-light:delete-outline', action: () => props.removeSpec(index()), color: 'danger', label: 'Eliminar' }
                ]}
                fullSwipe={false}
                onClick={() => props.openEditSpec(index())}
              >
                <div class="flex items-center gap-3 rounded-lg border border-border px-4 py-3 cursor-pointer">
                  <div class="flex-1 min-w-0">
                    <span class="font-medium text-foreground truncate">{spec.label}</span>
                    <p class="text-xs text-foreground-subtle mt-0.5">{spec.unit ? `${spec.value} ${spec.unit}` : spec.value}</p>
                  </div>
                  <Icon icon="material-symbols-light:chevron-right" size={20} class="text-foreground-subtle shrink-0" />
                </div>
              </SwipeAction>
            )}
          </For>

          <Show when={props.specs.length === 0}>
            <p class="text-sm text-foreground-subtle">Sin características. Las que añadas aquí se pueden usar luego para filtrar el catálogo.</p>
          </Show>
        </div>
      </Show>

      <Show when={!props.isMobile()}>
        <Table<DraftSpecType>
          data={props.specs}
          dense
          keyField="label"
          emptyMessage="Sin características. Las que añadas aquí se pueden usar luego para filtrar el catálogo."
          columns={[
            { header: 'Característica', accessor: (s: DraftSpecType) => <span class="font-medium text-foreground">{s.label}</span> },
            { header: 'Valor', accessor: (s: DraftSpecType) => <span class="text-foreground-subtle">{s.unit ? `${s.value} ${s.unit}` : s.value}</span> },
            {
              header: '',
              accessor: (s: DraftSpecType) => (
                <div class="flex justify-end gap-1">
                  <Button size="sm" variant="text" color="warning" icon="material-symbols-light:edit-outline" tooltip="Editar" onClick={() => props.openEditSpec(props.specs.indexOf(s))} />
                  <Button size="sm" variant="text" color="danger" icon="material-symbols-light:delete-outline" tooltip="Eliminar" onClick={() => props.removeSpec(props.specs.indexOf(s))} />
                </div>
              )
            }
          ]}
          pagination={false}
          pinnable={false}
        />
      </Show>
    </div>
  )
}

export default FichaTab
